import { gql } from 'urql';

const UPDATE_OBJECTIVES = gql`
  mutation UpdateObjectives(
    $_set: objectives_set_input!
    $ids: [Int!]!
    $activityObjects: [objectives_activity_insert_input!]!
    $activity: String
    $timestamp: bigint
    $userId: Int
  ) {
    update_objectives(where: { id: { _in: $ids } }, _set: $_set) {
      affected_rows
    }

    insert_objectives_activity(objects: $activityObjects) {
      affected_rows
    }
  }
`;

export default UPDATE_OBJECTIVES;
